import { useController, useFormContext } from 'react-hook-form'
import { classNames } from 'utils/classNames'

type Props = {
  label: string
  name: string
  required?: boolean
}
export const BooleanSelector = (props: Props): JSX.Element => {
  const { label, name, required } = props
  const { control } = useFormContext()
  const { field } = useController({ name, control })

  const availableList = [
    { key: '', value: '-' },
    { key: 'true', value: 'あり' },
    { key: 'false', value: 'なし' }
  ]
  const baseStyle =
    'w-full rounded border border-[#ddd] px-3 py-2 text-sm outline-none'

  // boolean | null → select の表示値（string）に変換
  const displayValue =
    field.value === null || field.value === undefined ? '' : String(field.value)

  return (
    <div className="flex flex-col">
      <label className={'mb-1.5 block text-sm font-medium text-[#555]'}>
        {label}
        {required && <span className={'text-red-500'}>{' *'}</span>}
      </label>
      <select
        ref={field.ref}
        name={field.name}
        className={classNames([baseStyle, 'focus:border-b-teal-400'])}
        value={displayValue}
        onBlur={field.onBlur}
        onChange={(e) => {
          const v = e.target.value
          field.onChange(v === '' ? null : v === 'true')
        }}
      >
        {availableList.map((data) => (
          <option value={data.key} key={data.key}>
            {data.value}
          </option>
        ))}
      </select>
    </div>
  )
}
